const language = {
    'pt': 
        {
            add_new:            'Adicionar novo',
            add_new_2:          'Adicionar aulas',
            calendar_language:  'pt-PT',
            calendar:           'Calendário',
            calendar_allday:    'Todo o dia',
            calendar_busy:      'Ocupado',
            calendar_daynames:  ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
            calendar_free:      'Livre',
            calendar_title_placeholder:     'Assunto',
            calendar_location_placeholder:  'Localização',
            calendar_start_placeholder:     'Data de inicio',
            calendar_end_placeholder:       'Data de fim',
            calendar_save:      'Salvar',
            calendar_update:    'Atualizar',
            calendar_edit:      'Editar',
            calendar_delete:    'Apagar aula',
            calendar_cancel:    'Cancelar marcação',
            calendar_today:     'Hoje',
            calendar_viewall:   'Ver tudo',
            calendar_month:     'Mês',
            calendar_week:      'Semana',
            calendar_day:       'Dia',
            calendar_group:     'Marcação para grupo',
            cancel:             'Cancelar',
            cancel_title:       'Cancelar Aula',
            cancel_text:        'Tem a certeza que pretende continuar?',
            cancel_confirm:     'Sim',
            cancel_cancel:      'Não',
            cancel_error:       'Problema ao cancelar registo!',
            cancel_success:     'Registo cancelado com sucesso!',
            category:           'Categoria',
            component:          'Aula',
            component_new:      'Novo aula',
            component_edit:     'Editar aula',
            component_list:     'Lista de aulas',
            component_group:    'Marcão para grupo',
            close:              'Fechar',
            color:              'Cor',
            color_placeholder:  'Introduza a cor',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_deny:          'Apagar',
            edit_error:         'Problema ao actualizar registo!',
            edit_success:       'Registo actualizado com sucesso!',
            edit_aula_title:    'Editar Registo',
            edit_aula_text:     'Tem a certeza que pretende continuar?',
            edit_aula_confirm:  'Editar',
            edit_aula_cancel:   'Cancelar',
            edit_aula_deny:     'Apagar',
            edit_aula_error:    'Problema ao actualizar registo!',
            edit_aula_success:  'Registo actualizado com sucesso!',
            end:                'Fim',
            field_category:     'Categoria',
            field_category_placeholder: 'Introduza a categoria',
            field_observation:  'Observação',
            field_observation_placeholder: 'Introduza uma observação',
            field_abreviation:  'Abreviatura',
            field_abreviation_placeholder: 'Introduza a abreviação',
            field_adultos:      'Adultos',
            field_adultos_placeholder: 'Introduza o número de adultos',
            field_criancas:     'Crianças',
            field_criancas_placeholder: 'Introduza o número de crianças',
            field_description:  'Descrição',
            field_description_placeholder: 'Introduza a descrição',
            field_forfait:      'Forfait',
            field_forfait_price:  'Preço do Forfait',
            field_forfait_price_placeholder: 'Introduza o preço do Forfait',
            field_forfait_taxe:  'IVA do Forfait',
            field_forfait_taxe_placeholder: 'Introduza o IVA do Forfait',
            field_equipamento:      'Equipamento',
            field_equipamento_price:  'Preço do Equipamento',
            field_equipamento_price_placeholder: 'Introduza o preço do Equipamento',
            field_equipamento_taxe:  'IVA do Equipamento',
            field_equipamento_taxe_placeholder: 'Introduza o IVA do Equipamento',
            field_final_price:  'Preço Final',
            field_final_price_palceholder: 'Introduza o Preço Final',
            field_price:        'Preço',
            field_name:         'Nome',
            field_name_placeholder: 'Introduza o nome',
            field_canhoes:      'Canhões de neve',
            field_status:       'Estado',
            field_comprimento:  'Comprimento',
            field_comprimento_placeholder: 'Inserir comprimento',
            field_dificuldade:     'Dificuldade',
            field_dificuldade_placeholder: 'Inserir dificuldade',
            field_desnivel:     'Desnível (m)',
            field_desnivel_placeholder: 'Inserir desnível (m)',
            field_type:         'Tipo',
            filter_placeholder: 'Procurar',
            id:                 'ID',
            image:              'Imagem',
            images:             'Imagens',
            image_choose:       'Escolher imagem',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_error_name:  'O nome é obrigatório.',
            insert_error_instrutor: 'O instrutor é obrigatório.',
            insert_error_category: 'A categoria é obrigatória.',
            insert_error_date:  'A data é obrigatória.',
            insert_error_horario:  'É obrigatório escolher pelo menos um horário.',
            insert_success:     'Registo inserido com sucesso!',
            instrutor:          'Instrutor',
            instrutor_placehoder:    'Inserir instrutor',
            location:           'Zona',
            location_placehoder:    'Inserir zona',
            principal:          'Principal',
            remove:             'Remover',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_dados:        'Dados da Aula',
            table_state:        'Estado',
            table_actions:      'Acções',
            table_empty:        'sem resultados',
            type:               'Tipo',
            type_placeholder:   'Inserir tipo',
            save:               'Salvar',
            start:              'Início',
            horario:            'Horário',
            finalize_order:     'Finalizar',  
            confirm_purchase_cancel:    'Cancelar finalização',
            confirm_purchase_confirm:   'Finalizar',
            confirm_purchase_error:     'Erro a processar o agendamento.',
            confirm_purchase_error_codigo: 'Erro a processar o agendamento, falta o código de compra, ou o código já foi usado.',
            confirm_purchase_success:   'Agendamento processado com sucesso.',
            confirm_purchase_text:      'Pretende finalizar o agendamento?',
            confirm_purchase_title:     'Confirmar agendamento',
            confirm_loader:             'A agendar...',
            cancel_scheduele_cancel:    'Cancelar agendamento',
            cancel_scheduele_confirm:   'Finalizar',
            cancel_scheduele_error:     'Erro a cancelar o agendamento.',
            cancel_scheduele_error_codigo: 'Erro a cancelar o agendamento, falta o código de compra, ou o código incorrecto.',
            cancel_scheduele_success:   'Agendamento cancelado com sucesso.',
            cancel_scheduele_text:      'Pretende cancelar o agendamento?',
            cancel_scheduele_title:      'Cancelar agendamento',
            cancel_scheduele_back:      'Voltar',
            aula_marcada_sub:           'Estância de Ski - Serra da Estrela - Aula marcada',
            aula_cancelada_sub:         'Estância de Ski - Serra da Estrela - Aula cancelada',
            cancel_aula_opt_01: 'Opção de cancelamento 1 titulo',
            cancel_aula_opt_01_txt: 'Estimado cliente,'
                + '<br/>'
                + 'No seguimento do cancelamento da(s) sua(s) aula(s), fica disponível para efetuar nova marcação seguindo o mesmo procedimento através da aplicação ou website, e apresentar no dia da sua visita. A marcação de aula(s) é obrigatória.'
                + '<br/>'
                + '<br/>'
                + 'Relembramos que o serviço continua válido para remarcação durante a presente época e a época seguinte (final de abril).'
                + '<br/>'
                + 'Obrigado.'
                + '<br/>'
                + '<br/>'
                + 'Atentamente,'
                + '<br/>'
                + 'Estância de Ski da Serra da Estrela',
            cancel_aula_opt_02: 'Opção de cancelamento 2 titulo',
            cancel_aula_opt_02_txt: 'Opção de cancelamento 1 descrição',
            cancel_aula_opt_03: 'Opção de cancelamento 3 titulo',
            cancel_aula_opt_03_txt: 'Opção de cancelamento 1 descrição',
            cancel_aula_opt_04: 'Opção de cancelamento 4 titulo',
            cancel_aula_opt_04_txt: 'Opção de cancelamento 1 descrição',
            cancel_aula_opt_05: 'Opção de cancelamento 5 titulo',
            cancel_aula_opt_05_txt: 'Opção de cancelamento 1 descrição',

            mail_scheduele_cancel_title:'Cancelar marcação de Aula',

            encomenda_marcacao:     'N.º da encomenda',
            data_marcacao:          'Data da marcação',
            hora_marcacao:          'Hora da Marcação',
            modalidade_marcacao:    'Tipo de Aula',
        },
    'en':
        {
            add_new:            'Add new',
            add_new_2:          'Add classes',
            calendar_language:  'pt-PT',
            calendar:           'Calendário',
            calendar_allday:    'Todo o dia',
            calendar_busy:      'Ocupado',
            calendar_daynames:  ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
            calendar_free:      'Livre',
            calendar_title_placeholder:     'Assunto',
            calendar_location_placeholder:  'Localização',
            calendar_start_placeholder:     'Data de inicio',
            calendar_end_placeholder:       'Data de fim',
            calendar_save:      'Salvar',
            calendar_update:    'Atualizar',
            calendar_edit:      'Editar',
            calendar_delete:    'Apagar aula',
            calendar_cancel:    'Cancelar marcação',
            calendar_today:     'Hoje',
            calendar_viewall:   'Ver tudo',
            calendar_month:     'Mês',
            calendar_week:      'Semana',
            calendar_day:       'Dia',
            calendar_group:     'Marcação para grupo',
            category:           'Category',
            cancel:             'Cancel',
            cancel_title:       'Cancelar Aula',
            cancel_text:        'Tem a certeza que pretende continuar?',
            cancel_confirm:     'Sim',
            cancel_cancel:      'Não',
            cancel_error:       'Problema ao cancelar registo!',
            cancel_success:     'Registo cancelado com sucesso!',
            component:          'Aula',
            component_new:      'New aula',
            component_edit:     'Edit aula',
            component_list:     'List of aulas',
            component_group:    'Marcão para grupo',
            close:              'Close',
            color:              'Color',
            color_placeholder:  'Insert the color',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_deny:          'Delete',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            edit_aula_title:    'Editar Registo',
            edit_aula_text:     'Tem a certeza que pretende continuar?',
            edit_aula_confirm:  'Editar',
            edit_aula_cancel:   'Voltar',
            edit_aula_deny:     'Apagar',
            edit_aula_error:    'Problema ao actualizar registo!',
            edit_aula_success:  'Registo actualizado com sucesso!',
            end:                'End',
            field_category:     'Categoria',
            field_category_placeholder: 'Introduza a categoria',
            field_observation:  'Observação',
            field_observation_placeholder: 'Introduza uma observação',
            field_abreviation:  'Abreviatura',
            field_abreviation_placeholder: 'Introduza a abreviação',
            field_adultos:      'Adultos',
            field_adultos_placeholder: 'Introduza o número de adultos',
            field_criancas:     'Crianças',
            field_criancas_placeholder: 'Introduza o número de crianças',
            field_description:  'Descrição',
            field_description_placeholder: 'Introduza a descrição',
            field_forfait:      'Forfait',
            field_forfait_price:  'Preço do Forfait',
            field_forfait_price_placeholder: 'Introduza o preço do Forfait',
            field_forfait_taxe:  'IVA do Forfait',
            field_forfait_taxe_placeholder: 'Introduza o IVA do Forfait',
            field_equipamento:      'Equipamento',
            field_equipamento_price:  'Preço do Equipamento',
            field_equipamento_price_placeholder: 'Introduza o preço do Equipamento',
            field_equipamento_taxe:  'IVA do Equipamento',
            field_equipamento_taxe_placeholder: 'Introduza o IVA do Equipamento',
            field_final_price:  'Preço Final',
            field_final_price_palceholder: 'Introduza o Preço Final',
            field_price:        'Preço',
            field_name:         'Nome',
            field_name_placeholder: 'Introduza o nome',
            field_canhoes:      'Canhões de neve',
            field_status:       'Estado',
            field_comprimento:  'Comprimento',
            field_comprimento_placeholder: 'Inserir comprimento',
            field_dificuldade:  'Dificuldade',
            field_dificuldade_placeholder: 'Inserir dificuldade',
            field_desnivel:     'Desnível (m)',
            field_desnivel_placeholder: 'Inserir desnível (m)',
            field_type:         'Tipo',
            filter_placeholder: 'Procurar',
            id:                 'ID',
            image:              'Imagem',
            images:             'Imagens',
            image_choose:       'Escolher imagem',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem updating element!',
            insert_error_name:  'O nome é obrigatório.',
            insert_error_instrutor: 'O instrutor é obrigatório.',
            insert_error_category: 'A categoria é obrigatória.',
            insert_error_date:  'A data é obrigatória.',
            insert_error_horario:  'É obrigatório escolher pelo menos um horário.',
            insert_success:     'Successful updated element!',
            instrutor:          'Instructer',
            instrutor_placehoder:    'Insert instructor',
            location:           'Location',
            location_placehoder:    'Insert location',
            principal:          'Principal',
            remove:             'Remove',
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_dados:        'Dados da Aula',
            table_state:        'State',
            table_actions:      'Actions',
            table_empty:        'no results',
            type:               'Type',
            type_placeholder:   'Insert type',
            save:               'Save',
            start:              'Start',
            horario:            'Horário',
            finalize_order:     'Finalizar', 
            confirm_purchase_cancel:    'Cancelar finalização',
            confirm_purchase_confirm:   'Finalizar',
            confirm_purchase_error:     'Erro a processar o agendamento.',
            confirm_purchase_error_codigo: 'Erro a processar o agendamento, falta o código de compra, ou o código já foi usado.',
            confirm_purchase_success:   'Agendamento processado com sucesso.',
            confirm_purchase_text:      'Pretende finalizar o agendamento?',
            confirm_purchase_title:     'Confirmar agendamento',
            confirm_loader:             'A agendar...',
            cancel_scheduele_cancel:    'Cancelar agendamento',
            cancel_scheduele_confirm:   'Finalizar',
            cancel_scheduele_error:     'Erro a cancelar o agendamento.',
            cancel_scheduele_error_codigo: 'Erro a cancelar o agendamento, falta o código de compra, ou o código incorrecto.',
            cancel_scheduele_success:   'Agendamento cancelado com sucesso.',
            cancel_scheduele_text:      'Pretende cancelar o agendamento?',
            cancel_scheduele_title:      'Cancelar agendamento',
            cancel_scheduele_back:      'Voltar',
            aula_marcada_sub:           'Estância de Ski - Serra da Estrela - Aula marcada',
            aula_cancelada_sub:         'Estância de Ski - Serra da Estrela - Aula cancelada',
            cancel_aula_opt_01: 'Opção de cancelamento 1 titulo',
            cancel_aula_opt_01_txt: 'Estimado cliente,'
                + '<br/>'
                + 'No seguimento do cancelamento da(s) sua(s) aula(s), fica disponível para efetuar nova marcação seguindo o mesmo procedimento através da aplicação ou website, e apresentar no dia da sua visita. A marcação de aula(s) é obrigatória.'
                + '<br/>'
                + '<br/>'
                + 'Relembramos que o serviço continua válido para remarcação durante a presente época e a época seguinte (final de abril).'
                + '<br/>'
                + 'Obrigado.'
                + '<br/>'
                + '<br/>'
                + 'Atentamente,'
                + '<br/>'
                + 'Estância de Ski da Serra da Estrela',
            cancel_aula_opt_02: 'Opção de cancelamento 2 titulo',
            cancel_aula_opt_02_txt: 'Opção de cancelamento 1 descrição',
            cancel_aula_opt_03: 'Opção de cancelamento 3 titulo',
            cancel_aula_opt_03_txt: 'Opção de cancelamento 1 descrição',
            cancel_aula_opt_04: 'Opção de cancelamento 4 titulo',
            cancel_aula_opt_04_txt: 'Opção de cancelamento 1 descrição',
            cancel_aula_opt_05: 'Opção de cancelamento 5 titulo',
            cancel_aula_opt_05_txt: 'Opção de cancelamento 1 descrição',

            mail_scheduele_cancel_title:'Cancelar marcação de Aula',

            encomenda_marcacao:     'N.º da encomenda',
            data_marcacao:          'Data da marcação',
            hora_marcacao:          'Hora da Marcação',
            modalidade_marcacao:    'Tipo de Aula',
        }
}

module.exports = {
    language
};